import React, { useContext } from "react";
import BookCard from "./BookCard";
import { IMAGES } from "../../assets";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context";
import Proptypes from "prop-types";

const BookListCard = ({ title, data, link, onClick, isError, percentage }) => {
  BookListCard.propTypes = {
    title: Proptypes.string,
    data: Proptypes.any,
    link: Proptypes.any,
    onClick: Proptypes.any,
    isError: Proptypes.any,
    percentage: Proptypes.number,
  };
  const navigate = useNavigate();
  const { activeLanguage } = useContext(AuthContext);
  return (
    <div className="px-3 py-2 bg-white rounded-md h-fit ">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-medium">{title}</h2>

        {link && (
          <button className="cursor-pointer" onClick={onClick}>
            <img
              className="w-6 h-auto"
              src={IMAGES?.forwardIcon}
              alt="rightArrow"
            />
          </button>
        )}
      </div>
      {isError ?? (
        <div className="">
          {data?.length > 0 ? (
            data?.slice(0, 4).map((item) => {
              return (
                <BookCard
                  key={item?._id}
                  isProgerss={percentage ?? false}
                  percentage={item?.books?.readingPercent}
                  img={
                    item?.bookImage ??
                    item?.eBookData?.bookImage ??
                    IMAGES?.bookLogo
                  }
                  name={item?.bookName ?? item?.eBookData?.bookName}
                  price={
                    activeLanguage === "Marathi"
                      ? "₹ " +
                        new Intl.NumberFormat("mr", {
                          maximumSignificantDigits: 2,
                        }).format(item?.eBookData?.price ?? item.price)
                      : "₹ " + (item.price ?? item?.eBookData?.price)
                  }
                  rating={item?.overallRating ?? item?.eBookData?.overallRating}
                  onClick={() =>
                    navigate(
                      `/aboutbook/${item?._id ?? item?.eBookData?._id}`,
                      {
                        state: { item: item },
                      }
                    )
                  }
                  //  ink={'/aboutbook'} l
                  type="horizontal"
                />
              );
            })
          ) : (
            <p className="text-center mt-2">No books available</p>
          )}
        </div>
      )}
    </div>
  );
};

export default BookListCard;
